import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../navbar/Navbar';
import Footer from '../footer/Footer';

const PublicLayout = () => {
  return (
    <div className="d-flex flex-column min-vh-100 bg-body">
      {/* Navbar tetap di atas */}
      <Navbar />
      
      {/* Konten Halaman (Homepage, Login, dll) */}
      <main className="flex-grow-1">
        <Outlet />
      </main>
      
      {/* Footer tetap di bawah */}
      <Footer />
    </div>
  );
};

export default PublicLayout;